import { ComposedChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ReferenceLine, ResponsiveContainer } from "recharts";

// Recharts paints the legend label in the series colour, so each entry here is
// text as well as a line. Minor is the one neutral in the scale and takes the
// ink token rather than a grey of its own, which is what kept it legible when
// the rest of the app moved off gray-500.
const SERIES = [
  { key: "critical", color: "#C62828" },
  { key: "serious", color: "#EA580C" },
  { key: "moderate", color: "#BF8700" },
  { key: "minor", color: "var(--ink-subtle)" },
];

export const TrendChart = ({ points, engineChanges }) => {
  if (!points?.length) {
    return (
      <p className="text-sm text-ink-muted py-10 text-center border border-dashed border-gray-300 rounded-sm" data-testid="trend-empty">
        No audits yet. Run an audit from the extension to start the trend.
      </p>
    );
  }
  const data = points.map((p) => ({ ...p, day: typeof p.day === "string" ? p.day.slice(0, 10) : p.day }));
  return (
    <div data-testid="trend-chart" role="img" aria-label="Violation count over time by impact severity">
      <ResponsiveContainer width="100%" height={280}>
        <ComposedChart data={data} margin={{ top: 10, right: 20, left: 0, bottom: 0 }}>
          <CartesianGrid stroke="#E5E7EB" strokeWidth={1} vertical={false} />
          {/* An axis prop named `stroke` sets the axis rule and, by default,
              the fill of every tick label hanging off it, which is how 11px
              dates ended up drawn in #9CA3AF at 2.54:1. The two are separated
              here: the rule stays a hairline in the same grey as the table
              borders, and the labels take the body ink, because they are text
              and 1.4.3 applies to them. */}
          <XAxis dataKey="day" tick={{ fontSize: 11, fontFamily: "IBM Plex Mono", fill: "var(--ink-muted)" }} stroke="#D1D5DB" />
          <YAxis allowDecimals={false} tick={{ fontSize: 11, fontFamily: "IBM Plex Mono", fill: "var(--ink-muted)" }} stroke="#D1D5DB" />
          <Tooltip contentStyle={{ borderRadius: 2, border: "1px solid #D1D5DB", fontFamily: "IBM Plex Mono", fontSize: 12 }} />
          <Legend wrapperStyle={{ fontSize: 12, fontFamily: "Public Sans" }} />
          {SERIES.map(({ key, color }) => (
            <Line key={key} type="monotone" dataKey={key} stroke={color} strokeWidth={1.5} dot={{ r: 2.5 }} isAnimationActive={false} />
          ))}
          {(engineChanges || []).map((c) => (
            <ReferenceLine
              key={c.day + c.engine_version}
              x={c.day}
              stroke="#16324F"
              strokeDasharray="4 3"
              label={{ value: `engine ${c.engine_version}`, position: "top", fontSize: 10, fill: "#16324F", fontFamily: "IBM Plex Mono" }}
            />
          ))}
        </ComposedChart>
      </ResponsiveContainer>
    </div>
  );
};
